/**
 * Anchor navigation — highlights the menu item whose anchor section is in view.
 * Strips WordPress current_page_item / current-menu-item from anchor links
 * so only the scroll-spy controls the active state.
 */
( function () {
	const anchorLinks = document.querySelectorAll(
		'.localads-header-top__nav a[href*="#"]'
	);

	if ( ! anchorLinks.length ) {
		return;
	}

	// Build a map of hash → menu <li>
	// Only handle anchors that point to the current page (same-page anchors).
	// Links to other pages keep their WP current_page_item class untouched.
	const currentPath = window.location.pathname;
	const sections = [];
	anchorLinks.forEach( ( link ) => {
		const hash = link.hash;
		if ( ! hash || hash === '#' ) {
			return;
		}
		// Skip anchors pointing to a different page
		if ( link.pathname !== currentPath ) {
			return;
		}
		const target = document.querySelector( hash );
		if ( target ) {
			const li = link.closest( 'li' );
			// Remove WP's active classes — scroll-spy will handle highlighting
			li.classList.remove(
				'current_page_item',
				'current-menu-item',
				'current_page_ancestor',
				'current-menu-ancestor'
			);
			sections.push( { el: target, li } );
		}
	} );

	if ( ! sections.length ) {
		return;
	}

	function update() {
		const scrollY = window.scrollY + window.innerHeight / 3;

		let current = null;
		sections.forEach( ( s ) => {
			if ( s.el.offsetTop <= scrollY ) {
				current = s;
			}
		} );

		sections.forEach( ( s ) => s.li.classList.remove( 'active-anchor' ) );
		if ( current ) {
			current.li.classList.add( 'active-anchor' );
		}
	}

	window.addEventListener( 'scroll', update, { passive: true } );
	update();
} )();
